<template>
<li :class="className">{{ text }}</li>
</template>

<script>

export default {
  props: [
    'text',
    'className'
  ]
}

</script>

<style lang="scss" scoped>

</style>
